import { render, staticRenderFns } from "./morexiaoxianv.vue?vue&type=template&id=e6bb5ff8&scoped=true"
import script from "./morexiaoxianv.vue?vue&type=script&lang=js"
export * from "./morexiaoxianv.vue?vue&type=script&lang=js"
import style0 from "./morexiaoxianv.vue?vue&type=style&index=0&id=e6bb5ff8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bb5ff8",
  null
  
)

export default component.exports